import config from "@/config";
import { FormField } from "@/types";
import questionaryInfoFields from "@/questionaryFieldsConfig";

export const getQuestionaryInfoFields = () => {
  return questionaryInfoFields.filter(i => (config.questionaryHiddenField as string[]).indexOf(i.name) === -1);
};

export const normalizedFields = (
  fields: (FormField & { fieldMeta?: Record<any, any> })[],
  values: Record<string, string>
) => {
  fields.forEach(field => {
    if (!values[field.name]) return;

    let result = values[field.name].trim().replace(field.fieldMeta?.replaceRegExp, "");

    if (result && field.fieldMeta?.regExp) {
      if (field.fieldMeta.appendText) {
        if (!field.fieldMeta.regExp.test(result)) {
          result = `${field.fieldMeta.appendText}${result}`;
        }
      } else {
        const execResult: RegExpExecArray = field.fieldMeta.regExp.exec(result);
        if (execResult[1]) result = execResult[1];
      }
    }
    values[field.name] = result;
  });
};
